<template>
  <div v-if="mobile">
    <div v-if="$route.name === 'mathlete' && typeof (athlete) !== 'undefined'" class="menu_bar">
      <div class="col-xs-2 nopadding">
        <div class="favicon menu_icon back router-link-active" @click="pop">
          <i class="icon-back"></i>
        </div>
      </div>
      <div class="col-xs-6 nopadding">
        <span v-if="athlete.team_id" class="menu_text nameoverflow" id="athletename">
          <img v-if="athlete.country_code"  style="height:15px; width:15px;" v-bind:src="getFlag(athlete)"> {{athlete.team.name}}
        </span>
        <span v-else-if="athlete.first_name" class="menu_text nameoverflow" id="athletename">
          <img v-if="athlete.country_code"  style="height:20px; width:20px;" v-bind:src="getFlag(athlete)"> {{athlete.first_name}} {{athlete.last_name}} - ({{athlete.bib_id}})
        </span>
      </div>
      <div class="col-xs-2">
        <span class="menu_text ">
          <span v-if="isStatus(athlete)" class="withdrawn" id="statuspane">{{statusText(athlete)}}</span>
        </span>
      </div>
      <span class="favicon menu_icon_fav col-xs-2" @click="toggleFavourite(athlete)">
        <center>
          <favIcon v-bind:gender="athlete.gender" v-bind:aid="athlete.id"/>
        </center>
      </span>
    </div>
    <div v-else-if="$route.name === 'mcheckpoint'" class="sidebar_header">
      <div class="col-xs-1 nopadding">
        <div class="favicon menu_icon back router-link-active" @click="pop">
          <i class="icon-back"></i>
        </div>
      </div>
      <div class="col-xs-1 nopadding">
        <div class="favicon menu_icon" @click="pop">
          <i class="cp_icon icon-timepoint"></i>
        </div>
      </div>
      <div class="col-xs-7 pl-1">
        <span class="menu_text nameoverflow" id="athletename">{{checkpoint.name}}</span>
      </div>
    </div>
    <nav v-else class="menu_bar">
			<div>
        <div class="navbar-header mainmenu">
          <div class="col-sm-9 nopadding">
            <router-link class="menu_icon" :to="{ name: 'map'}">
              <i class="icon icon-map"></i>
            </router-link>
            <router-link class="menu_icon" :to="{ name: 'mleaderboard'}">
              <i class="icon icon-leaderboard"></i>
            </router-link>
            <router-link class="menu_icon" :to="{ name: 'mfollowing'}">
              <i class="icon icon-activated"></i>
            </router-link>
            <router-link v-if="eve.id === 220" class="menu_icon" :to="{ name: 'msocial'}">
              <i class="icon icon-facebook"></i>
            </router-link>
            <router-link class="menu_icon pull-right" :to="{ name: 'menu'}">
              <i class="icon icon-menu"></i>
            </router-link>
          </div>
        </div>
      </div>
    </nav>
  </div>
  <div v-else-if="!mobile">
    <div v-if="$route.name === 'athlete' && typeof (ath) !== 'undefined'" class="sidebar_header">
      <div class="col-xs-1 nopadding">
        <div class="favicon menu_icon back router-link-active" @click="pop">
          <i class="icon-back"></i>
        </div>
      </div>
      <div class="col-xs-7 nopadding">
        <span v-if="ath.team_id" class="menu_text nameoverflow" id="athletename">
          <img v-if="ath.country_code" style="height:15px; width:15px;" v-bind:src="getFlag(ath)"> {{testAth.team.name}}
        </span>
        <span v-else-if="ath.first_name" class="menu_text nameoverflow" id="athletename">
          <img v-if="ath.country_code"  style="height:20px; width:20px;" v-bind:src="getFlag(ath)"> {{ath.first_name}} {{ath.last_name}} - ({{athlete.bib_id}})
        </span>
      </div>
      <div class="col-xs-3">
        <span class="menu_text ">
          <span v-if="isStatus(ath)" class="withdrawn" id="statuspane">{{statusText(ath)}}</span>
        </span>
      </div>
      <span class="favicon menu_icon_fav col-xs-1" @click="toggleFavourite(ath)">
        <center>
          <favIcon v-bind:gender="ath.gender" v-bind:aid="ath.id"/>
        </center>
      </span>
    </div>
    <div v-else-if="$route.name === 'checkpoint'" class="sidebar_header">
      <div class="col-xs-1 nopadding">
        <div class="favicon menu_icon back router-link-active" @click="pop">
          <i class="icon-back"></i>
        </div>
      </div>
      <div class="col-xs-1 nopadding">
        <div class="favicon menu_icon" @click="pop">
          <i class="cp_icon icon-timepoint"></i>
        </div>
      </div>
      <div class="col-xs-7 pl-1">
        <span class="menu_text nameoverflow" id="athletename">{{checkpoint.name}}</span>
      </div>
    </div>
    <div v-else class="navbar-header mainmenu sidebar_header">
      <div class="col-xs-4" style="padding-left: 5px;padding-right: 0px; font-size: 12px">
        <router-link class="menu_icon" :to="{ name: 'leaderboard'}">
          <i class="icon icon-leaderboard" style="margin-left: 0px; margin-right: 0px"></i> LEADERBOARD
        </router-link>
      </div>
      <div class="col-xs-4" style="padding-left: 0px;padding-right: 0px;">
        <router-link class="menu_icon" :to="{ name: 'following'}">
          <i class="icon icon-favourite"></i> FOLLOWING
        </router-link>
      </div>
      <div v-if="eve.id === 220" class="col-xs-4" style="padding-left: 0px;padding-right: 0px;">
        <router-link class="menu_icon" :to="{ name: 'social'}">
          <i class="icon icon-favourite"></i> SOCIAL
        </router-link>
      </div>
      <!--<div class="col-xs-3" style="padding-left: 0px;padding-right: 0px;">-->
        <!--<router-link v-if="$route.name !== 'details'" class="menu_icon" :to="{ name: 'details'}">-->
          <!--<i class="glyphicon glyphicon-chevron-right"></i> DETAILS-->
        <!--</router-link>-->
        <!--<div v-else class="menu_icon router-link-active" @click="pop">-->
          <!--<i class="glyphicon glyphicon-chevron-right"></i> DETAILS-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <router-view></router-view>
  </div>
</template>
<style>
.menu_icon_fav {
  float: left;
  height: 50px;
  font-size: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  line-height: 24px;
}
.menu_icon_fav a:hover {
    color: #1fa9e2;
}
.menu_icon_fav a:focus {
    color: #1fa9e2;
}
.menu_icon_fav a:active {
    color: #1fa9e2;
}
.menu_icon_fav.active {
    color: #1fa9e2;
    text-decoration: none;
    border-bottom: 3px solid #1fa9e2;
}

  .menu_bar{

  }


</style>
<script>
import { mapGetters } from 'vuex'
import favIcon from './favicon'

export default{
  data: function () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      eve: 'event',
      mobile: 'mobile',
      athlete: 'focusedAthlete',
      ath: 'athlete',
      favourites: 'favourites',
      testAth: 'getLoadedRaceAthlete',
      checkpoints: 'checkpoints'
    }),
    checkpoint () {
      return this.checkpoints[this.$route.params.id]
    }
  },
  components: {
    favIcon
  },
  methods: {
    pop: function () {
      if(this.mobile) {
        this.$router.go(-1)
      } else {
        this.$router.replace('../leaderboard')
      }
    },
    isStatus: function (ath) {
      if (typeof (ath.id) !== 'undefined') {
        return !!(ath.isFinished || ath.withdrawn_at !== null)
      }
    },
    statusText: function (ath) {
      if (ath.withdrawn_at !== null) {
        return 'WITHDRAWN'
      } else if (ath.isFinished) {
        return 'FINISHED'
      }
    },
    getFlag: function (ath) {
      return ath.country_code === null ? '' : 'https://app.sportraxs.com/images/svg/' + ath.country_code.toLowerCase() + '.svg'
    },
    toggleFavourite: function (ath) {
      if (typeof (ath.id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete remove: ' + ath.id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete add: ' + ath.id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.id)
        }
      } else if (typeof (ath.team_id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.team_id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team remove: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.team_id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team add: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.team_id)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routing.vue